import { useEffect } from 'react';

/**
 * Apple Sign In Callback Page
 * 
 * This page handles the redirect from Apple's authentication service.
 * It simply displays a success message and returns a 200 status.
 * In a production environment, this would handle token validation and user redirection.
 */
const AppleCallback = () => {
  useEffect(() => {
    // Log the successful callback for debugging
    console.log('Apple Sign In callback received successfully');
    
    // In a real implementation, you might:
    // 1. Extract tokens from URL parameters
    // 2. Validate the tokens
    // 3. Store user session
    // 4. Redirect to the app
    
    // For now, we're just closing the popup window if this is in a popup
    if (window.opener) {
      window.opener.postMessage({ type: 'APPLE_AUTH_SUCCESS' }, window.location.origin);
      window.close();
    }
  }, []);

  return (
    <div className="flex flex-col items-center justify-center min-h-screen bg-gray-50">
      <div className="p-8 bg-white rounded-lg shadow-md max-w-md w-full text-center">
        <h1 className="text-2xl font-bold mb-4">Authentication Successful</h1>
        <p className="mb-4">
          You have successfully authenticated with Apple.
        </p>
        <p className="text-sm text-gray-500">
          This window will close automatically if opened as a popup.
        </p>
      </div>
    </div>
  );
};

export default AppleCallback;
